import createReducer from '../utils/createReducer';
import {
  CANCELLATION_REASONS_REQUEST,
  CANCELLATION_REASONS_FAILURE,
  CANCELLATION_REASONS_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [CANCELLATION_REASONS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [CANCELLATION_REASONS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [CANCELLATION_REASONS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/cancellationReasons.js